import React from 'react';
import './BadgeMarque.css';

// Marque du véhicule, affichée là où un réceptionnaire trie son travail par
// marque (file de réception des concessions multimarques).
//
// Le logo est une DONNÉE du référentiel (`marques.logo_url`), pas un fichier du
// dépôt : SOGUAVA voit déjà passer 14 marques, dont X-Peng et SsangYong — les
// figer dans le code imposerait un déploiement à chaque nouvelle marque.
// Quand le logo manque (ou casse au chargement), la pastille à initiale prend
// le relais : aucun écran ne doit dépendre d'un fichier qu'un administrateur
// aurait oublié de renseigner.
//
// `nom` vide ⇒ rien n'est rendu par défaut. Passer `placeholder` pour afficher
// le « ? » gris (« marque à préciser ») sur les cartes où la colonne doit
// rester alignée.
export default function BadgeMarque({ nom, logoUrl, couleur, taille = 20, placeholder = false, titre }) {
  const [logoKo, setLogoKo] = React.useState(false);
  if (!nom && !placeholder) return null;

  const style = { width: taille, height: taille };
  const montrerLogo = !!logoUrl && !logoKo;

  return (
    <span
      className={`badge-marque${nom ? '' : ' badge-marque--vide'}`}
      style={style}
      title={titre || (nom ? `Marque : ${nom}` : 'Marque à préciser')}
      aria-label={nom || 'Marque à préciser'}
    >
      {montrerLogo ? (
        <img src={logoUrl} alt="" onError={() => setLogoKo(true)} />
      ) : (
        <span
          className="badge-marque__initiale"
          style={{ fontSize: Math.round(taille * 0.55), color: nom ? (couleur || undefined) : undefined }}
        >
          {nom ? nom.charAt(0).toUpperCase() : '?'}
        </span>
      )}
    </span>
  );
}
